// src/Components/WalletDashboardCard.js
import React from "react";
import { useWallet } from "../../Context/WalletContext";
import { FaDollarSign } from "react-icons/fa";
import { formatBalance } from "../../Utils/numberFormatter";


const WalletCard = ({ index }) => {
  const { balance, lastUpdate, error, isLoading, reload } = useWallet();

  return (
    <div
      className="bg-grayish rounded-2xl p-6 flex flex-col justify-between shadow-md  transition-all duration-500 ease-out border border-grayish opacity-0 translate-y-6 animate-fadeSlideUp"
      style={{ animationDelay: `${index * 150}ms` }}
    >
      {/* الأيقونة */}
      <div className="flex items-center justify-start">
        <div className="bg-main1/20 p-3 rounded-full">
          <FaDollarSign className="text-main1 text-lg" />
        </div>
      </div>

      {/* المحتوى */}
      <div className="mt-4 flex-1">
        {isLoading ? (
          <p className="text-sm text-gray-500">جاري تحميل الرصيد ...</p>
        ) : error ? (
          <div className="text-sm text-accent">
            <p>{error.message || "حدث خطأ ما"}</p>
            <button onClick={reload} className="text-xs underline mt-1">
              إعادة المحاولة
            </button>
          </div>
        ) : (
          <>
            <p className="text-main1 font-bold text-2xl flex items-baseline gap-1 ">
              <small className="text-sm ">ليرة سورية</small>
              <span>{formatBalance(balance)}</span>
            </p>
            <p className="text-gray-500 text-sm mt-1">رصيد المحفظة</p>
          </>
        )}
      </div>

      {/* آخر تحديث */}
      {!isLoading && !error && (
        <p className="text-xs text-main1 mt-4">
          {lastUpdate ? `آخر تحديث: ${lastUpdate}` : ""}
        </p>
      )}
    </div>
  );
};

export default WalletCard;
